import React, { useMemo, useState, useEffect } from 'react';
import { Button, Form } from 'react-bootstrap';
import { useDispatch } from 'react-redux'; 
import { setOrder } from '../../Global/OrderSlice';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus,faMinus} from '@fortawesome/free-solid-svg-icons';
import style from '../../Styles/Order/Order.module.css';
import Enum  from '../../Common/Enum/Enum';
import ModalMessage from '../../Components/Html/ModalMessage';
import MessageAlert from '../../Components/Html/MessageAlert';
import IngredientsBeverageCheckboxs from './IngredientsBeverageCheckboxs';

const Order = ({ menuItem }) => {
  
  const dispatch = useDispatch(); 
  const [notes, setNotes] = useState('');
  const [quantity, setQuantity] = useState('1');
  const [checkboxValues, setCheckboxValues] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [pendingOrderItem, setPendingOrderItem] = useState(null);
  const [messagetext, setMessageText] = useState('');
  const [typeMessagetext, setTypeMessagetext] = useState();

  useEffect(() => {
    if (messagetext) {
      const timer = setTimeout(() => {
        setMessageText('');
        setTypeMessagetext(undefined);
      }, 3000);      
      return () => clearTimeout(timer);
    }
  }, [messagetext]);

  useEffect(() => {
    if (menuItem?.ingredients?.length) {
      const initialValues = {};      
      menuItem.ingredients.forEach(ingredient => {
        if (ingredient.typeOfHtmlElement === Enum.ISCHECKBOX) {
          initialValues[ingredient.idmenuchartproduct] = ingredient.ischecked === Enum.ISCHECKED;
        }
      });     
      setCheckboxValues(initialValues);
    }
  }, [menuItem]);

  const handleAddToOrderClick = () => {
    
        const beverageIngredients = menuItem.ingredients?.filter(
          ingredient => ingredient.isbeverage === 1
        ) || [];
    
        if (beverageIngredients.length > 0) {
              const hasSelectedBeverage = beverageIngredients.some(
              ingredient => checkboxValues[ingredient.idmenuchartproduct] === true
        );
      
        if (!hasSelectedBeverage) {        
          setMessageText("Por favor seleccione sabor de bebida");
          setTypeMessagetext(2);
          return;
        }
    }

    const selectedIngredients = {};
    
    menuItem.ingredients.forEach(ingredient => {
      if (ingredient.typeOfHtmlElement === Enum.ISCHECKBOX) {
        selectedIngredients[ingredient.idmenuchartproduct] = {
          id: ingredient.idmenuchartproduct,
          name: ingredient.name,
          selected: checkboxValues[ingredient.idmenuchartproduct] || false,
          isbeverage: ingredient.isbeverage
        };
      }
    });
       
    
    const selectedIngredientsNames = Object.values(selectedIngredients)
    .filter(ingredient => ingredient.selected === true && ingredient.isbeverage === 0)
    .map(ingredient => ingredient.name)
    .join(', ');

    const selectedBeverages = Object.values(selectedIngredients)
    .filter(ingredient => ingredient.selected === true && ingredient.isbeverage === 1)
    .map(ingredient => ingredient.name);
    
    const updatedNotes = notes 
    ? ` Notas : ${notes} | Ingredientes: ${selectedIngredientsNames} | Bebida : ${selectedBeverages}` : `Ingredientes: ${selectedIngredientsNames} | Bebida : ${selectedBeverages}`;

    
    const orderItem = {      
      id: menuItem.idMenuOption , 
      idproductcombo : menuItem.idproductcombo,     
      name: menuItem.name,
      price: menuItem.sellprice,
      quantity: parseInt(quantity) || 1, 
      notes: notes,
      notesaux: updatedNotes,
      ingredients: selectedIngredients, 
      imagePath: menuItem.imagePath,
      timestamp: new Date().toISOString()
    };    
    setPendingOrderItem(orderItem);    
    setShowModal(true);
  };

  const handleConfirmOrder = () => {    
    if (pendingOrderItem ){
      dispatch(setOrder(pendingOrderItem));
    }
    setShowModal(false);
    setPendingOrderItem(null);
  };

  const handleCancelOrder = () => {
    setShowModal(false);
    setPendingOrderItem(null);
  };

  const formControls = useMemo(() => (
    <div className={style.submitblock}>
      <div>
        <Form.Control 
          as="textarea" 
          placeholder='Notas a la orden.' 
          className={style.comments}
          value={notes}
          onChange={(e) => setNotes(e.target.value)}
        />
      </div>    
      <div className={style.submitinnerblock}>
        <Form.Control 
          type="number" 
          placeholder='Cantidad' 
          className={style.cantidad}
          value={quantity}
          onChange={(e) => {
            const newValue = e.target.value;            
            if (newValue === '') {
              setQuantity('');
            } else {
              const numValue = parseInt(newValue, 10);
              if (!isNaN(numValue) && numValue >= 1) {
                setQuantity(numValue);
              }
            }
          }}
          min="1"
          step="1"
          readOnly 
        />
        <Button className={`${style.buttonPlus} btn btn-light`}  onClick={() => setQuantity(prev => {
            const newValue = typeof prev === 'string' ? parseInt(prev, 10) : prev;
            return (newValue || 0) + 1;})}>
          <FontAwesomeIcon icon={faPlus} className={style.iconPlus} />
        </Button>
        <Button className={`${style.buttonMinus} btn btn-light`}  onClick={() => setQuantity(prev => {
            const newValue = typeof prev === 'string' ? parseInt(prev, 10) : prev;
            const decreased = (newValue || 0) - 1;
            return decreased >= 1 ? decreased : 1;})}>
          <FontAwesomeIcon icon={faMinus} className={style.iconMinus} />
        </Button>
        <Button className={style.buttonAgregar} onClick={handleAddToOrderClick}>
          Agregar
        </Button>
      </div>
    </div>
  ), [notes, quantity,handleAddToOrderClick]);

  return (
    <div className={style.mainContainer} onClick={(e) => e.stopPropagation()}>    
      <div className={style.firstContainer}>
        <div className={style.imageblock} style={{ background: `url(${menuItem.imagePath}) no-repeat center/cover` }}> 
          <div className={style.sellPrice} translate="no">
            Q.{menuItem.sellprice}
          </div>         
        </div>
      </div>
      
      <div className={style.secondContainer}> 
        <div className={style.menuTitle}>
          <div>{menuItem.name}</div> 
        </div>
       
        <div className={style.ingredientsBeverageblock}>
        {formControls}
          <IngredientsBeverageCheckboxs
              menuItem={menuItem}
              checkboxValues={checkboxValues}
              setCheckboxValues={setCheckboxValues}/>
          
        </div>
        <MessageAlert text={messagetext} typeOfMessage={typeMessagetext}/>
        <div className={style.orderdivision}></div>
        
      </div>
      
      <ModalMessage 
        show={showModal}
        onConfirm={handleConfirmOrder}
        onCancel={handleCancelOrder}
        menuItemName={menuItem.name}
        quantity={quantity}
        typeOfMessage= {Enum.CONFIRMITEMTOCCART}
      />

    </div>
  );
};

export default Order;